import { CaretDownIcon } from "@phosphor-icons/react";
import { Dropdown } from "antd";
import { Button } from "@libertify/ui";
import { ItemType } from "antd/es/menu/interface";
import { useMemo } from "react";
import { ThemeResponse } from "pages/media/components/themeEditor/hooks/useThemeApi/";
import { ThemeGroup } from "..";
import { useTranslate } from "@refinedev/core";

export type ThemeDropdownProps = {
  themeGroups: ThemeGroup[];
  handleSelectTheme: (theme: ThemeResponse) => void;
  dropdownOpen?: boolean;
  setDropdownOpen?: (open: boolean) => void;
  label?: string;
  style?: React.CSSProperties;
};

export const ThemeDropdown = ({
  themeGroups,
  handleSelectTheme,
  dropdownOpen = false,
  setDropdownOpen,
  label,
  style,
}: ThemeDropdownProps) => {
  const t = useTranslate();
  const menuItems = useMemo(
    (): ItemType[] =>
      themeGroups.map((group) => ({
        key: group.key,
        type: "group" as const,
        label: group.label,
        children: group.themes.map((themeItem) => ({
          key: themeItem.id,
          label: themeItem.name,
          onClick: () => handleSelectTheme(themeItem),
        })),
      })),
    [themeGroups, handleSelectTheme]
  );

  return (
    <Dropdown
      onOpenChange={setDropdownOpen}
      open={dropdownOpen}
      trigger={["click"]}
      menu={{ items: menuItems }}
    >
      <Button
        variant="outlined"
        style={{ width: "100%", justifyContent: "space-between", ...style }}
      >
        {label ?? t("media.themeEditor.selectATheme")}
        <CaretDownIcon
          size={14}
          style={{
            transition: "transform 0.2s ease",
            transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Button>
    </Dropdown>
  );
};
